import { Box, Button, Link, Stack, Typography } from '@mui/material';
import { getAsset } from 'src/utils';
import { useMenuContext } from '../context';
import { TMenuAddress, TMenuContact, TMenuWhitelabel } from '../types';
import { Mail, MapPin } from 'lucide-react';

type Props = {
  whitelabel?: TMenuWhitelabel;
  contact?: TMenuContact;
  address?: TMenuAddress;
  isBM?: boolean;
  sendToGA: (type: string, obj: any, isMultiPaths?: boolean) => void;
};

export const BottomSection = ({ whitelabel, contact, address, isBM, sendToGA }: Props) => {
  const { colors, translation } = useMenuContext();

  return (
    <Stack
      sx={{
        width: '100%',
        marginTop: 'auto',
        padding: 1,
        backdropFilter: 'blur(10.5px)',
      }}
      spacing={1}
    >
      {contact?.phone && isBM && (
        <Button
          sx={{
            borderRadius: 1,
            background: colors.btnBg,
            color: colors.btnText,
            textTransform: 'none',
            '&:hover': {
              background: colors.btnHover,
              color: colors.btnText,
            },
          }}
          fullWidth
          startIcon={<Mail size={14} />}
          onClick={() => {
            sendToGA('event', {
              eventCategory: 'GetInTouch',
              eventAction: 'click',
            });
            contact.onClick();
          }}
        >
          {translation?.getInTouch || 'Get In Touch'}
        </Button>
      )}
      {address && address.label && isBM && (
        <Button
          fullWidth
          variant="text"
          startIcon={<MapPin size={14} />}
          onClick={address.onClick}
          sx={{
            color: colors.text,
            textTransform: 'none',
            alignItems: 'start',
            justifyContent: 'center',
            gap: '10px',
            '.MuiButton-startIcon': {
              margin: '5px',
            },
          }}
        >
          <Typography>
            {address.label}
          </Typography>
        </Button>
      )}
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        justifyContent="center"
        sx={{
          color: colors.text,
          background: colors.bg,
          marginLeft: '-8px !important',
          marginRight: '-8px !important',
          marginBottom: '-8px !important',
          paddingY: 0.5,
          paddingX: 2,
          height: '36px',
        }}
      >
        <Typography
          sx={{
            whiteSpace: 'nowrap',
          }}
        >
          {translation?.producedBy || 'Produced By'}
        </Typography>
        <Link
          rel="noreferrer"
          target="_blank"
          href={whitelabel?.website}
          sx={{
            display: 'flex',
          }}
          onClick={() => {
            sendToGA('event', {
              eventCategory: 'ProducedBy',
              eventAction: 'click',
            });
          }}
        >
          <Box
            component="img"
            src={whitelabel?.logo || getAsset('logo-white.svg')}
            sx={{
              maxHeight: '30px',
              width: '100%',
              objectFit: 'contain',
            }}
          />
        </Link>
      </Stack>
    </Stack>
  );
};
